import * as React from 'react';

/////////////////// Loading Page
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';

import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Box from '@mui/joy/Box';
import Table from '@mui/joy/Table';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import IconButton from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Divider from '@mui/material/Divider';
import DialogTitle from '@mui/joy/DialogTitle';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { visuallyHidden } from '@mui/utils';

import { styled } from '@mui/joy/styles';
import Grid from '@mui/joy/Grid';



////////////////// Pagintion
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';



/////////////////// Modal
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////// Date Formate
import dateFormat, { masks } from "dateformat";




////////////////////// Icons Images
// import DeleteIconImage from '../../assets/icons/trashCar.svg'
// import EditIconImage from '../../../assets/icons/eiditIconMove.svg'
// import DubleIcon from '../../../assets/icons/dubleIcon.svg'
import EyeIcon from '../../assets/icons/eye.svg'

///////////////////// API
import { getAllOrders, getOrderDetails, getOrdersByFilter, getPaymentFilter, getOthersOrders } from '../../Api/Orders';

function createData(title, country, phone, brand_name, model_name, price, actions) {
    return {
        title,
        country,
        phone,
        brand_name,
        model_name,
        price,
        actions
    };
}


function labelDisplayedRows({ from, to, count }) {
    return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'title',
        numeric: false,
        disablePadding: true,
        label: 'اسم الشركة',
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'البريد الالكترونى',
    },
    {
        id: 'phone',
        numeric: true,
        disablePadding: false,
        label: 'رقم الهاتف',
    },
    {
        id: 'createAt',
        numeric: true,
        disablePadding: false,
        label: 'التاريخ',
    },
    {
        id: 'amount',
        numeric: true,
        disablePadding: false,
        label: 'المبلغ',
    },
    // {
    //     id: 'price',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'سعر السيارة جديدة الأن',
    // },
    // {
    //     id: 'finalPrice',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'السعر النهائى',
    // },
    // {
    //     id: 'actions',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'الاجرءات',
    // },
];

function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <thead>
            <tr style={
                { 'background': '#F3F3F3', 'color': '#7C7C7C', fontWeight: 'bold' }
            }>
                {headCells.map((headCell) => {
                    const active = orderBy === headCell.id;
                    return (
                        <th
                            key={headCell.id}
                            aria-sort={
                                active ? { asc: 'ascending', desc: 'descending' }[order] : undefined
                            }
                        >
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <Link
                                underline="none"
                                color="neutral"
                                textColor={active ? 'primary.plainColor' : undefined}
                                component="button"
                                onClick={createSortHandler(headCell.id)}
                                fontWeight="lg"
                                startDecorator={
                                    headCell.numeric ? (
                                        <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                                    ) : null
                                }
                                endDecorator={
                                    !headCell.numeric ? (
                                        <ArrowDownwardIcon sx={{ opacity: active ? 1 : 0 }} />
                                    ) : null
                                }
                                sx={{
                                    '& svg': {
                                        transition: '0.2s',
                                        transform:
                                            active && order === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)',
                                    },
                                    '&:hover': { '& svg': { opacity: 1 } },
                                }}
                            >
                                {headCell.label}
                                {active ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </Link>
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected } = props;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                py: 1,
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: 'background.level1',
                }),
                borderTopLeftRadius: 'var(--unstable_actionRadius)',
                borderTopRightRadius: 'var(--unstable_actionRadius)',
            }}
        >
            {numSelected > 0 ? (
                <Typography sx={{ flex: '1 1 100%' }} component="div">
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography
                    level="body-lg"
                    sx={{ flex: '1 1 100%' }}
                    id="tableTitle"
                    component="div"
                >
                    Nutrition
                </Typography>
            )}
        </Box>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function FinancialReport({
    startDate,
    endDate,
    filterAction
}) {
    const navigate = useNavigate()

    const [order, setOrder] = React.useState('asc');
    const [orderDetails, setOrderDetails] = React.useState(null);
    const [loadingData, setLoadingData] = React.useState(false)
    const [loadingDetails, setLoadingDetails] = React.useState(false)

    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20000);
    const [rows, setRows] = React.useState([])
    const [modelId, setModelId] = React.useState(null)
    const [openModalConfirm, setOpenModalConfirm] = React.useState(false)
    const [openModelDetails, setOpenModelDetails] = React.useState(false)

    const [loading, setLoading] = React.useState(false)
    const [openAlert, setOpenAlert] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState('');

    const [openAlertError, setOpenAlertError] = React.useState(false);
    const [messageAlertError, setMessageAlertError] = React.useState('');


    const [currentPage, setCurrentPage] = React.useState(1);
    const [countPage, setCountPage] = React.useState(0)

    let objPagination = {
        page: 1,
    }

    let objFilter = {
        startDate: startDate,
        endDate: endDate,
        page:1,
        payment_type:2
    }


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event, newValue) => {
        setRowsPerPage(parseInt(newValue.toString(), 10));
        setPage(0);
    };

    const getLabelDisplayedRowsTo = () => {
        if (rows.length === -1) {
            return (page + 1) * rowsPerPage;
        }
        return rowsPerPage === -1
            ? rows.length
            : Math.min(rows.length, (page + 1) * rowsPerPage);
    };

    // const openConfirmDelete = (id) => {
    //     setModelId(id)
    //     setOpenModalConfirm(true)
    // };

    // const deleteBrand = async () => {

    // }

    const openDetalisRow = async (e, id) => {
        e.preventDefault();
        setLoadingDetails(true)
        const res = await getOrderDetails(id)
        if (res) {
            setLoadingDetails(false)
            // return
            setOrderDetails(res)
            setModelId(id)
            setOpenModelDetails(true)
        }
    }


    const isSelected = (name) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const getOrders = async () => {
        setLoadingData(true)
        const res = await getPaymentFilter(objFilter);
        if (res.data.data) {
            // let newArray = res.data.map((order) => {
            //     if(order.payment_status	== 'success') {
            //         order.payment_status = 'عملية ناجحه'
            //         return order
            //     }else if(order.payment_status	== 'expired'){
            //         order.payment_status = 'انتهت صلاحية العملية'
            //         return order
            //     }else if(order.payment_status	== 'pending'){
            //         order.payment_status = 'قيد الانتظار'
            //         return order
            //     }else if(order.payment_status	== 'declined'){
            //         order.payment_status = 'تم الرفض'
            //         return order
            //     }else if(order.payment_status	== 'cancelled'){
            //         order.payment_status = 'تم الغاء'
            //         return order
            //     }else if(order.payment_status	== 'cancelled'){
            //         order.payment_status = 'فشلت العملية'
            //         return order
            //     }else{
            //         return order
            //     }
            // })
            setLoadingData(false)
            setRows(res.data.data)
            setCountPage(res.data.last_page)
            setCurrentPage(res.data.current_page)
        }
        setLoadingData(false)

    }

    const getListOrdersByFilter = async () => {
        if (objFilter.startDate == null && objFilter.endDate == null) {
            getOrders()
        } else {
            setLoadingData(true)
            const res = await getOrdersByFilter(objFilter, objPagination)
            if (res.data) {
                let newArray = res.data.map((order) => {
                    if(order.payment_status	== 'success') {
                        order.payment_status = 'عملية ناجحه'
                        return order
                    }else if(order.payment_status	== 'expired'){
                        order.payment_status = 'انتهت صلاحية العملية'
                        return order
                    }else if(order.payment_status	== 'pending'){
                        order.payment_status = 'قيد الانتظار'
                        return order
                    }else if(order.payment_status	== 'declined'){
                        order.payment_status = 'تم الرفض'
                        return order
                    }else if(order.payment_status	== 'cancelled'){
                        order.payment_status = 'تم الغاء'
                        return order
                    }else if(order.payment_status	== 'cancelled'){
                        order.payment_status = 'فشلت العملية'
                        return order
                    }else{
                        return order
                    }
                })
                setLoadingData(false)
                setRows(newArray)
                setCountPage(res.last_page)
                setCurrentPage(res.current_page)
            }

        }
    }

    const handleChangePagePagintion = async (e, newValuePage) => {
        objPagination.page = newValuePage
        objFilter.page = newValuePage
        setCurrentPage(newValuePage)
        getOrders()
    }



    React.useEffect(() => {
        getOrders();
    }, [])

    React.useEffect(() => {
        getOrders();
    }, [filterAction])


    return (
        <>

            {/* Alert Message */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            {/* Modal PopUp */}
            <Modal
                aria-labelledby="modal-title"
                aria-describedby="modal-desc"
                open={openModalConfirm}
                onClose={() => setOpenModalConfirm(false)}
                sx={{ overflowY: 'scroll' }}>
                <ModalDialog
                    aria-labelledby="modal-title"
                    aria-describedby="modal-desc"
                    sx={(theme) => ({
                        height: '100%',
                        direction: 'rtl',
                    })}

                >

                </ModalDialog>
            </Modal>


            {/* Modal Order Details */}
            {orderDetails != null && (
                <Modal
                    aria-labelledby="modal-title"
                    aria-describedby="modal-desc"
                    open={openModelDetails}
                    onClose={() => setOpenModelDetails(false)}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll', paddingTop: '150px' }}
                >
                    <Sheet
                        variant="outlined"
                        sx={{
                            Width: 500,
                            borderRadius: 'md',
                            p: 3,
                            boxShadow: 'lg',
                            position: 'relative',
                        }}
                    >
                        {/* <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold' }}>إضافة خبر</DialogTitle> */}
                        {/* <ModalClose variant="plain" sx={{ m: 1, position: 'absolute', left: '0' }} /> */}
                        <Box sx={{ width: '500px', paddingTop: '30px', direction: 'rtl' }}>
                            <Typography id="nested-modal-title" level="h4">
                                تفاصيل السياره
                            </Typography>
                            <Divider sx={{ margin: '20px 0' }} />
                            <Typography id="nested-modal-title" level="h4">
                                معلومات العميل
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                columns={12}
                                sx={{ width: '100%' }}
                            >
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>اسم العميل</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>                                            
                                        {orderDetails.order_details && orderDetails.order_details.name != null ? orderDetails.order_details.name : "لايوجد بيانات"}
                                    </Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>البريد الألكترونى</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.user.email ? orderDetails.user.email : 'لا يوجد بريد بيانات'}</Typography>
                                </Grid>

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>رقم الهاتف</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.user.phone ? orderDetails.user.phone : 'لايوجد بيانات'}</Typography>
                                </Grid>

                                {/* <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>المنطقة</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.order_details ? orderDetails.order_details.country : 'لايوجد بيانات'}</Typography>
                                </Grid> */}

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>المدينة</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.city ? orderDetails.city.name_ar : 'لايوجد بيانات'}</Typography>
                                </Grid>

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>الغرض من التقييم</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.purpose == 1 ? 'معرفة قيمة السيارة' : orderDetails.purpose == 2 ? 'بيع سيارة' : orderDetails.purpose == 3 ? 'اغراض تجارية' : ''}</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ margin: '20px 0' }} />
                            <Typography id="nested-modal-title" level="h4">
                                معلومات السيارة
                            </Typography>
                            <Grid
                                container
                                rowSpacing={3}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                                columns={12}
                                sx={{ width: '100%' }}
                            >
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>ماركة السيارة</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.brand ? orderDetails.brand.title_en : 'لايوجد بيانات'}</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>موديل السياره</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.car_model ? orderDetails.car_model.name_en : 'لايوجد بيانات'}</Typography>
                                </Grid>

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>سنة الصنع</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.made_year ? orderDetails.made_year : 'لايوجد بيانات'}</Typography>
                                </Grid>

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>حاله السيارة</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.car_case == 1 ? 'جديدة' : 'مستعملة'}</Typography>
                                </Grid>

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>حالة الجيربوكس</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.gearbox == 1 ? 'مستعمل' : 'جديد'}</Typography>
                                </Grid>

                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>المسافة المقطوعة</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.kilos ? orderDetails.kilos + ' كم ' : 'لايوجد بيانات'} </Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>سعر السيارة جديدة بالريال</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.current_price ? orderDetails.current_price + ' ريال سعودى ' : 'لايوجد بيانات'} </Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>حاله الرش</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.damage_pieces == 0 ? 'لايوجد رش' : 'يوجد رش'}</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#7C7C7C' }}>السعر النهائى</Typography>
                                </Grid>
                                <Grid xs={6}>
                                    <Typography level="title-lg" sx={{ fontSize: '16px', color: '#000000' }}>{orderDetails.final_price ? Math.floor(orderDetails.final_price) + ' ريال سعودى' : 'لايوجد بيانات'}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Sheet>
                </Modal>
            )}

            {loadingDetails ? (
                // <Box sx={{ position:'fixed', inset:0, background:'rgba(31,50,122,.5)', zIndex:'9'  }}>
                <CircularProgress color='secondary' sx={{ position: 'fixed', inset: '0', margin: 'auto', zIndex: '2' }} />            // </Box>
            ) : null}

            <Sheet
                variant="outlined"
                sx={{ width: '100%', boxShadow: 'sm', borderRadius: 'sm' }}
            >
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <Table
                    aria-labelledby="tableTitle"
                    hoverRow
                    sx={{
                        '--TableCell-headBackground': 'transparent',
                        '--TableCell-selectedBackground': (theme) =>
                            theme.vars.palette.success.softBg,
                        '& thead th:nth-child(1)': {
                            // width: '40px',
                            textAlign: 'center'
                        },
                        '& tr > *:nth-child(n+3)': { textAlign: 'center' },

                        '& tr > *:nth-child(1)': { textAlign: 'center' },
                    }}
                >
                    <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                    />
                    <tbody>
                        {stableSort(rows, getComparator(order, orderBy))
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                const isItemSelected = isSelected(row.name);
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <tr
                                        onClick={(event) => handleClick(event, row.name)}
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        // selected={isItemSelected}
                                        style={
                                            isItemSelected
                                                ? {
                                                    '--TableCell-dataBackground':
                                                        'var(--TableCell-selectedBackground)',
                                                    '--TableCell-headBackground':
                                                        'var(--TableCell-selectedBackground)',
                                                }
                                                : {}
                                        }
                                    >
                                        <th id={labelId} scope="row">
                                            {row.order != null && row.order.order_details && row.order.order_details.name != null ? row.order.order_details.name : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row">
                                            {row.user ? row.user.email : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row" dir='ltr'>
                                            {row.user ? row.user.phone : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row">
                                            {row.created_at	 ? dateFormat(row.created_at, "yyyy-mm-dd") : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row">
                                            {row.amount ? row.amount : "لايوجد بيانات"}
                                        </th>
                                        {/* <th id={labelId} scope="row">
                                            {row.current_price ? row.current_price + ' ريال سعودى' : "لايوجد بيانات"}
                                        </th>
                                        <th id={labelId} scope="row">
                                            {row.final_price ? row.final_price + ' ريال سعودى' : "لايوجد بيانات"}
                                        </th> */}
                                        
                                        {/* <td>
                                            <IconButton variant='plain' sx={{ color: '#7C7C7C', fontSize: '12px' }}>
                                                <img src={EyeIcon} alt='delete icon' className='eyeIcon' onClick={(e) => openDetalisRow(e, row.id)} />
                                                رؤيه التفاصيل

                                            </IconButton>
                                        </td> */}
                                    </tr>
                                );
                            })}
                        {emptyRows > 0 && (
                            <tr
                                style={{
                                    height: `calc(${emptyRows} * 40px)`,
                                    '--TableRow-hoverBackground': 'transparent',
                                }}
                            >
                                <td colSpan={6} aria-hidden />
                            </tr>
                        )}
                    </tbody>

                </Table>
            </Sheet>
            {loadingData ? (
                <LinearProgress />
            ) : null}
            <Stack spacing={2} alignItems='center' mt='30px'>
                <Pagination count={countPage} page={currentPage} color="primary" sx={{ margin: 'auto', direction: 'ltr' }} onChange={handleChangePagePagintion} />
            </Stack>
        </>


    );
}